// codigo extraido de:
// https://www.geeksforgeeks.org/check-if-two-given-line-segments-intersect/

// Given three collinear points p, q, r, the function checks if
// point q lies on line segment 'pr'
const onSegment = (p, q, r) => {
  if (
    q.x <= Math.max(p.x, r.x) &&
    q.x >= Math.min(p.x, r.x) &&
    q.y <= Math.max(p.y, r.y) &&
    q.y >= Math.min(p.y, r.y)
  )
    return true
  return false
}

const orientation = (p, q, r) => {
  // to find the orientation of an ordered triplet (p,q,r)
  // function returns the following values:
  // 0 : Collinear points
  // 1 : Clockwise points
  // 2 : Counterclockwise

  // See https://www.geeksforgeeks.org/orientation-3-ordered-points/amp/
  // for details of below formula.

  const val = (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y)
  if (val > 0)
    // Clockwise orientation
    return 1
  else if (val < 0)
    // Counterclockwise orientation
    return 2
  // Collinear orientation
  else return 0
}

// The main function that returns true if
// the line segment 'p1q1' && 'p2q2' intersect.
export const doIntersect = (p1, q1, p2, q2) => {
  // Find the 4 orientations required for
  // the general && special cases
  const o1 = orientation(p1, q1, p2),
    o2 = orientation(p1, q1, q2),
    o3 = orientation(p2, q2, p1),
    o4 = orientation(p2, q2, q1)

  // General case
  if (o1 !== o2 && o3 !== o4) return true

  // Special Cases

  // p1 , q1 && p2 are collinear && p2 lies on segment p1q1
  if (o1 === 0 && onSegment(p1, p2, q1)) return true

  // p1 , q1 && q2 are collinear && q2 lies on segment p1q1
  if (o2 === 0 && onSegment(p1, q2, q1)) return true

  // p2 , q2 && p1 are collinear && p1 lies on segment p2q2
  if (o3 === 0 && onSegment(p2, p1, q2)) return true

  // p2 , q2 && q1 are collinear && q1 lies on segment p2q2
  if (o4 === 0 && onSegment(p2, q1, q2)) return true

  // If none of the cases
  return false
}
